import { createAction, props } from '@ngrx/store';
import { ILoginState } from './login';
import { LoginPayload } from '../../interfaces/login-payload';
import {
  IPayloadCambioPassword,
  IResponseCambioPassword,
} from '../../interfaces/change-password';
import { CodeTipologiaCPEnum } from '../../enum/cod-tipologia-cp.enum';

export const LOGIN = createAction(
  '[LOGIN] - submit login',
  props<{ body: LoginPayload }>()
);

export const LOGIN_SUCCESS = createAction(
  '[LOGIN] - submit login success',
  props<{ responseLogin: ILoginState }>()
);

export const LOGIN_RESET = createAction('[LOGIN] - reset');

export const CAMBIO_PASSWORD = createAction(
  '[LOGIN] - cambio password',
  props<{ payload: IPayloadCambioPassword }>()
);

export const CAMBIO_PASSWORD_SUCCESS = createAction(
  '[LOGIN] - cambio password success',
  props<{ responseCambioPassword: IResponseCambioPassword | null }>()
);

export const SET_COD_TIPOLOGIA_CP = createAction(
  '[LOGIN] - set cod tipologia cp',
  props<{ codTipologiaCp: CodeTipologiaCPEnum | undefined }>()
);

export const LOGOUT = createAction(
  '[LOGOUT] - submit logout'
)
